export const ERROR_MASK = {
  errorMask: 'errors',
};
